import User from '@/models/User'
import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    userDetails: null
  },

  mutations: {
    setUserList(state, users) {
      state.list = map(users, user => new User(user))
    },

    setUserListMeta(state, meta) {
      state.listMeta = meta
    },

    setUserDetails(state, user) {
      state.userDetails = new User(user)
    },

    clearUserDetails(state) {
      state.userDetails = null
    }
  },

  actions: {
    async getUsers({ commit }, params) {
      let query = ''

      if (params.page) {
        query += `page=${params.page}`
      }

      if (params.search) {
        query += `&filter[search]=${params.search}`
      }

      if (params.limit) {
        query += `&limit=${params.limit}`
      }

      const { data } = await Api.get(`users?${query}`)
      commit('setUserList', data.data)
      commit('setUserListMeta', data.meta)
    },

    async getUserDetails({ commit }, id) {
      const { data } = await Api.get(`users/${id}`)
      commit('setUserDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      await Api.post(`users/${formData.get('user_id')}/avatar`, formData)
    },

    async updateUser({ commit }, formData) {
      await Api.put(`users/${formData.id}`, formData)
    }
  }
}
